import i18n from "@i18n/i18n";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { observer } from "mobx-react";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";

export interface MultiGridToolbarSearchFilterProps {
  /**
   * Allow parent to control search actions.
   * @param searchText
   * @returns
   */
  onChange?: (searchText: string) => void;
  /**
   * The current search text value.
   */
  value?: string | undefined;
  /**
   * If `true`, search text changes are propagated as the user types.
   * Debouncing for server requests should be handled by the parent.
   * @default true.
   */
  quickSearch?: boolean;
}

const MultiGridToolbarSearchFilter = observer((props: MultiGridToolbarSearchFilterProps) => {
  //console.log(`MultiGridToolbarSearchFilter:`, props);
  const [searchText, setSearchText] = useState(props.value ?? "");
  const quickSearch = props.quickSearch ?? true;

  useEffect(() => {
    if (props.value !== undefined && props.value !== searchText) {
      setSearchText(props.value);
    }
  }, [props.value]);

  const handleSearch = () => {
    props.onChange?.(searchText);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    setSearchText(nextValue);
    if (quickSearch) {
      props.onChange?.(nextValue);
    }
  };

  const handleSearchReset = () => {
    setSearchText("");
    props.onChange?.("");
  };

  const handleApplySearch = (event: KeyboardEvent<HTMLInputElement>) => {
    if (!quickSearch && event.key === "Enter") {
      props.onChange?.(searchText);
    }
  };

  return (
    <Box>
      <TextField
        variant="standard"
        value={searchText}
        onChange={handleSearchChange}
        onKeyDown={handleApplySearch}
        placeholder={i18n.t("quick-search-toolbar.placeholder")}
        slotProps={{
          input: {
            startAdornment: (
              <IconButton title={i18n.t("assign-material-dialog.search-button.title")} onClick={handleSearch}>
                <SearchIcon fontSize="small" />
              </IconButton>
            ),
            endAdornment: (
              <IconButton title={i18n.t("assign-material-dialog.clear-button.title")} sx={{ visibility: searchText ? "visible" : "hidden" }} onClick={handleSearchReset}>
                <ClearIcon fontSize="small" />
              </IconButton>
            ),
          },
        }}
      />
    </Box>
  );
});

export default MultiGridToolbarSearchFilter;
